export const screenTabletUp = 768;
export const screenDesktopUp = 1200;

export const isBelowDesktop = () => {
  return window.innerWidth < screenTabletUp;
};

export const isAboveDesktop = () => {
  return window.innerWidth >= screenDesktopUp;
};
